export default __webpack_public_path__ + "static/media/meuLogo.2b3497cf.png";